export const TOGGLE_DESTINATION_NOT_REACH_YET = 'TOGGLE_DESTINATION_NOT_REACH_YET'

export function displayDestinationNotReachYetReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_DESTINATION_NOT_REACH_YET:
            return action.payload
        default: return state
    }
}